(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxr-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initPxr(root){
    var track=root.querySelector('.pxr__track');
    var dotsWrap=root.querySelector('.pxr__dots');
    if(!track||!dotsWrap) return;
    var cards=track.children;
    function step(){var c=cards[0];var gap=parseFloat(getComputedStyle(track).columnGap)||24;return c?c.getBoundingClientRect().width+gap:track.clientWidth;}
    dotsWrap.innerHTML='';
    for(var i=0;i<cards.length;i++){
      var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Go to review '+(i+1));
      (function(idx){b.addEventListener('click',function(){track.scrollTo({left:idx*step(),behavior:'smooth'});});})(i);
      dotsWrap.appendChild(b);
    }
    function setActive(){var idx=Math.round(track.scrollLeft/step());var ds=dotsWrap.children;for(var j=0;j<ds.length;j++)ds[j].classList.toggle('is-active',j===idx);}
    track.addEventListener('scroll',function(){requestAnimationFrame(setActive);});
    var prev=root.querySelector('.pxr__prev'),next=root.querySelector('.pxr__next');
    if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    if(next)next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    setActive();
  }
  function initAll(){document.querySelectorAll('.pxr').forEach(initPxr);}
  if(document.readyState!=='loading')initAll();else document.addEventListener('DOMContentLoaded',initAll);
  document.addEventListener('shopify:section:load',function(e){if(e.target)e.target.querySelectorAll('.pxr').forEach(initPxr);});
})();

  } catch(e) { console.error(e); }
})();
})();
